module.exports = __webpack_public_path__ + "img/close.2fdb73e8.svg";